import { useOrganizationPartnersQuery } from '@client/graphql/__generated__/main-operations';
import { OrganizationPartnerItemFragment } from '@client/graphql/__generated__/types';
import { createContext, ReactNode, useCallback, useContext } from 'react';
import { useAppContext } from '~/services/main/contexts/AppContext';

interface NotificationsContextType {
  partners: OrganizationPartnerItemFragment[];
  loadingPartners: boolean;
  refetchPartners: () => void;
}

const NotificationsContext = createContext<NotificationsContextType>(
  {} as NotificationsContextType
);

export const NotificationsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { selectedOrganization } = useAppContext();

  const { data, loading, refetch } = useOrganizationPartnersQuery({
    variables: {
      organizationId: selectedOrganization?.id ?? '',
      perPage: 50,
    },
    skip: !selectedOrganization?.id,
  });

  const partners = data?.organizationPartners?.results ?? [];

  const refetchPartners = useCallback(() => {
    void refetch();
  }, [refetch]);

  return (
    <NotificationsContext.Provider
      value={{
        partners,
        loadingPartners: loading,
        refetchPartners,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotificationsContext = () => {
  return useContext(NotificationsContext);
};
